import { addHours, getHours, getMinutes, setHours, setMinutes } from "date-fns";

/**
 * Calculates endHour and endMinutes from startHour, startMinutes, and duration in hours.
 * Handles hour overflow (e.g., if start is 22:00 and duration is 3 hours, end is 01:00 next day).
 *
 * @param startHour - Starting hour (0-23)
 * @param startMinutes - Starting minutes (0-59)
 * @param durationHours - Duration in hours (can be fractional, e.g., 1.5 for 1 hour 30 minutes)
 * @returns Object with endHour and endMinutes
 */
export function calculateEndTimeFromDuration(
  startHour: number,
  startMinutes: number,
  durationHours: number
): { endHour: number; endMinutes: number } {
  // Create a date object at midnight for the base day
  const baseDate = new Date(2024, 0, 1, 0, 0, 0);

  // Set the start time
  const startDate = setMinutes(setHours(baseDate, startHour), startMinutes);

  // Add the duration
  const endDate = addHours(startDate, durationHours);

  // Extract hours and minutes (handles overflow automatically)
  return {
    endHour: getHours(endDate),
    endMinutes: getMinutes(endDate)
  };
}
